
import { CLIENTS } from '../../../helpers/constants'
import * as SearchByTagsHelpers from './helper'


export const SEARCH_BY_TAGS_COLUMNS = {
  [CLIENTS.CLEAROUT.NAME]: [
    {
      label: 'Sr No.',
      renderCell: SearchByTagsHelpers.srNoFormatter,
    },
    {
      label: 'Name',
      renderCell: (user) => SearchByTagsHelpers.nameFormatter(user, CLIENTS.CLEAROUT.NAME),
      pinLeft: true
    },
    {
      label: 'Email / Phone',
      renderCell: (user) => SearchByTagsHelpers.contactFormatter(user, CLIENTS.CLEAROUT.NAME),
    },
    {
      label: 'User Tags',
      renderCell: SearchByTagsHelpers.userTagsFormatter,
    },
    {
      label: 'Credits',
      renderCell: SearchByTagsHelpers.creditsFormatter,
    },
    {
      label: 'Recur',
      renderCell: SearchByTagsHelpers.recurFormatter,
    },
    {
      label: 'Low Credit Notification Threshold',
      renderCell: SearchByTagsHelpers.lowCreditThresholdFormatter,
    },
    {
      label: 'Role',
      renderCell: SearchByTagsHelpers.roleFormatter,
    },
    {
      label: 'User Source',
      renderCell: SearchByTagsHelpers.userSourceFormatter,
    },
    {
      label: 'Channel Source',
      renderCell: SearchByTagsHelpers.channelSourceFormatter,
    },
    {
      label: 'Channel Source Campaign',
      renderCell: SearchByTagsHelpers.channelSourceCampaignFormatter,
    },
    {
      label: 'Channel Source Query',
      renderCell: SearchByTagsHelpers.channelSourceQueryFormatter,
    },
    {
      label: 'Affiliate',
      renderCell: SearchByTagsHelpers.affiliateFormatter,
    },
    {
      label: 'Sign Up IP',
      renderCell: SearchByTagsHelpers.signUpIpFormatter,
    },
    {
      label: 'Sign UP Country',
      renderCell: SearchByTagsHelpers.signUpCountryFormatterer,
    },
    {
      label: 'Activated On',
      renderCell: SearchByTagsHelpers.activatedOnFormatter,
    },
    {
      label: 'Created On',
      renderCell: SearchByTagsHelpers.createdOnFormatter,
    },
    {
      label: 'Account Delete Reason',
      renderCell: SearchByTagsHelpers.accountDeleteReasonFormatter,
    },
    {
      label: 'User Id',
      renderCell: SearchByTagsHelpers.userIdFormatter,
    },
  ]
}